(() => {
  const root = document.querySelector('[data-wl-stats]');
  if (!root) return;

  const counters = root.querySelectorAll('[data-wl-counter]');
  if (!counters.length) return;

  const animate = (el) => {
    const target = Number(el.getAttribute('data-target') || 0);
    const duration = 1100;
    const start = performance.now();

    const tick = (now) => {
      const t = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - t, 3);
      el.textContent = String(Math.round(target * eased));
      if (t < 1) requestAnimationFrame(tick);
    };

    requestAnimationFrame(tick);
  };

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        counters.forEach(animate);
        io.disconnect();
      });
    },
    { threshold: 0.35 }
  );

  io.observe(root);
})();
